<template>
    <div class="precharge">
        <Header ref="header" :title="title" @backPage="onBack"></Header>
        <div class="title textCenter bold">单分享平台</div>
        <div class="subTitle textCenter bold">活动预充服务协议</div>
        <div class="content">
            <p class="bold">【首部及导言】</p>
            <p>欢迎会员使用单分享平台活动预充服务！</p>
            <p class="bold">《单分享平台活动预充服务协议》（以下简称“本协议”）由会员与江苏好享家电子商务有限公司共同缔结，本协议具有合同效力。</p>
            <p class="bold">为参与单分享平台折扣采购活动，会员使用活动预充服务前应当阅读并遵守本协议。请会员务必审慎阅读、充分理解各条款内容，特别是免除或者减轻我们责任的条款、管辖与法律适用条款。限制、免责条款可能以黑体加粗形式提示会员注意。</p>
            <p class="bold">除非会员已阅读并接受本协议所有条款，否则会员无权使用预充服务及享有平台后续活动产品的优惠采购政策。会员使用平台预充服务即视为会员已阅读并同意上述协议的约束。</p>
            <p class="bold">一、【协议的范围】</p>
            <p>1.1 本协议是会员与好享家之间关于会员为参加平台活动而同意使用预充服务所订立的协议。“好享家”是指江苏好享家电子商务有限公司及其相关服务可能存在的运营关联单位。“会员”是指经注册后使用单分享平台相关服务的使用人。</p>
            <p>1.2 本协议项下的服务是指活动预充平台服务，具体是指好享家通过单分享平台向会员提供的技术服务平台，会员通过使用平台活动预充服务向平台运营商或第三方进行指定产品或业务的充值（以下简称“本服务”）。</p>
            <p>1.3 会员已知悉，<span class="bold">本协议项下的服务仅是好享家为会员提供充值业务的技术服务平台，好享家不是向会员提供充值服务的服务商或代理商，会员使用前述服务过程中所涉及的支付服务由中金支付有限公司（以下简称“壹企付”）提供，会员应同时遵守壹企付的相关规定。</span></p>
            <p class="bold">二、【帐号与密码安全】</p>
            <p>2.1 会员在使用平台活动预充服务时需要先注册帐号，关于会员使用该帐号的具体规则，请遵守单独协议。</p>
            <p>2.2 会员使用不同的账号所享受的本服务内容可能会存在不同，会员对此表示完全理解并同意。</p>
            <p>2.3 好享家特别提醒会员应妥善保管会员的帐号和密码。当会员使用完毕后，应安全退出。<span class="bold">因会员保管不善可能导致遭受盗号或密码失窃，责任由会员自行承担。</span></p>
            <p class="bold">三、【使用本服务的方式及范围】</p>
            <p>3.1 本协议项下的预充服务的对象仅限单分享平台活动区域已认证的会员。</p>
            <p>3.2 会员已知悉，使用单分享平台活动预充服务，是单分享平台中发布的产品优惠活动中，会员<span class="bold">支付预付货款</span>的方式。</p>
            <p>3.3 活动预充服务政策：</p>
            <p>3.3.1 活动当天0点前预充相应金额至单分享活动预充，作为活动产品采购的预付货款；</p>
            <p>3.3.2 根据会员的预充金额，在活动期间购买相应活动产品享有相应的优惠，具体优惠政策以每场活动为准</p>
            <p>3.3.3 活动前，<span class="bold">会员预充金额会被限制提现及支付，仅可作为活动采购预付款，在活动期间采购活动产品时抵扣货款；</span>活动结束后预充金额未使用或有剩余的，可选择预留在活动预充参与下次活动。</p>
            <p>会员在平台活动预充充值的金额在充值期间不计息。</p>
            <p>3.4 会员应当通过好享家提供或认可的方式使用本服务。会员依本协议条款所取得的权利不可转让。</p>
            <p>3.5 会员不得使用未经好享家授权的插件、外挂或第三方工具对本协议项下的服务进行干扰、破坏、修改或施加其他影响。</p>
            <p class="bold">四、【会员注意事项】</p>
            <p>4.1 好享家不对会员在本软件及服务中相关数据的删除或储存失败负责；</p>
            <p>4.2 如果会员停止使用本服务或服务被终止或取消，好享家可以从服务器上永久地删除会员的数据。服务停止、终止或取消后，好享家没有义务向会员返还任何数据。</p>
            <p>4.3 会员在使用本服务时，须自行承担如下来自平台不可掌控的风险内容，包括但不限于：</p>
            <p>4.3.1 由于不可抗拒因素可能引起的信息丢失、泄漏等风险；</p>
            <p>4.3.2 如果需下载软件，会员必须选择与所安装手机相匹配的软件版本，否则，由于软件与手机型号不相匹配所导致的任何问题或损害，均由会员自行承担；</p>
            <p>4.3.3 会员在使用本服务访问第三方网站时，因第三方网站及相关内容所可能导致的风险，由会员自行承担；</p>
            <p>4.3.4 由于无线网络信号不稳定、无线网络带宽小等原因，所引起的会员登录失败、资料同步不完整、页面打开速度慢等风险。</p>
            <p class="bold">4.3.5 会员对其所充值的产品或业务享有合法权益，保证不会侵犯任何第三方的合法权益，保证不会违反国家相关法律法规的规定。</p>
            <p class="bold">4.4 第三方产品和服务</p>
            <p class="bold">4.4.1 会员在使用本服务第三方提供的产品或服务时，除遵守本协议约定外，还应遵守第三方的服务协议。好享家和第三方对可能出现的纠纷在法律规定和约定的范围内各自承担责任。</p>
            <p class="bold">4.4.2 因会员使用本服务或要求好享家提供特定服务时，本服务会调用第三方系统或者通过第三方支持会员的使用或访问，使用或访问的结果由该第三方提供，好享家不保证通过第三方提供服务及内容的安全性、准确性、有效性及其他不确定的风险，由此若引发的任何争议及损害，与好享家无关，好享家不承担任何责任。</p>
            <p class="bold">五、【按现状提供服务】</p>
            <p><span class="bold">会员理解并同意，</span>单分享平台服务是按照现有技术和条件所能达到的现状提供的。好享家会尽最大努力向会员提供服务，确保服务的连贯性和安全性；但好享家不能随时预见和防范法律、技术以及其他风险，<span class="bold">包括但不限于不可抗力、病毒、木马、黑客攻击、系统不稳定、第三方服务瑕疵、政府行为等原因可能导致的服务中断、数据丢失以及其他的损失和风险。</span></p>

            <p class="bold">六、【知识产权声明】</p>
            <p>6.1 好享家在本服务中提供的内容（包括但不限于网页、文字、图片、音频、视频、图表等）的知识产权归好享家所有，会员在使用本服务中所产生的内容的知识产权归会员或相关权利人所有。</p>
            <p>6.2 除另有特别声明外，好享家提供本服务时所依托软件的著作权、专利权及其他知识产权均归好享家所有。</p>
            <p>6.3 好享家在本服务中所使用的“好享家”等商业标识，其著作权或商标权归好享家所有。</p>
            <p>6.4 上述及其他任何本服务包含的内容的知识产权均受到法律保护，未经好享家、会员或相关权利人书面许可，任何人不得以任何形式进行使用或创造相关衍生作品。</p>

            <p class="bold">七、【不可抗力及其他免责事由】</p>
            <p class="bold">7.1 会员理解并同意，在使用本服务的过程中，可能会遇到不可抗力等风险因素，使本服务发生中断、延迟或受阻。不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行和风暴等以及社会事件如战争、动乱、政府行为等。出现上述情况时，好享家将努力在第一时间与相关单位配合，及时进行修复，但是由此给会员造成的损失好享家在法律允许的范围内免责。</p>
            <p class="bold">7.2 好享家作为技术服务平台仅按现状提供服务，在法律允许的范围内，好享家对以下情形导致的服务中断、延迟受阻不承担责任：</p>
            <p class="bold">（1）受到计算机病毒、木马或其他恶意程序、黑客攻击的破坏；</p>
            <p class="bold">（2）会员、第三方或好享家的电脑软件、系统、硬件、网络和通信线路出现故障；</p>
            <p class="bold">（3）会员操作不当，包括但不限于会员提交错误的充值号码或账号错误；</p>
            <p class="bold">（4）会员通过非好享家授权的方式使用本服务；</p>
            <p class="bold">（5）其他好享家无法控制或合理预见的情形。</p>
            <p class="bold">7.3 会员理解并同意，在使用本服务的过程中，可能会遇到网络信息或其他会员行为带来的风险，好享家不对任何信息的真实性、适用性、合法性承担责任，也不对因侵权行为给会员造成的损害负责。这些风险包括但不限于：</p>
            <p class="bold">（1）来自他人匿名或冒名的含有威胁、诽谤、令人反感或非法内容的信息；</p>
            <p class="bold">（2）因使用本协议项下的服务，遭受他人误导、欺骗或其他导致或可能导致的任何心理、生理上的伤害以及经济上的损失；</p>
            <p class="bold">（3）其他因网络信息或会员行为引起的风险。</p>
            <p class="bold">7.4 会员理解并同意，本服务并非为某些特定目的而设计，包括但不限于核设施、军事用途、医疗设施、交通通讯等重要领域。如果因为软件或服务的原因导致上述操作失败而带来的人员伤亡、财产损失和环境破坏等，好享家不承担法律责任。</p>
            <p class="bold">7.5 好享家依据本协议约定获得处理违法违规内容的权利，该权利不构成好享家的义务或承诺，好享家不能保证及时发现违法行为或进行相应处理。</p>
            <p class="bold">7.6 在任何情况下，会员不应轻信借款、索要密码或其他涉及财产的网络信息。涉及财产操作的，请一定先核实对方身份，并请经常留意好享家有关防范诈骗犯罪的提示。</p>

            <p class="bold">八、【协议的生效与变更】</p>
            <p class="bold">会员使用好享家的服务即视为会员已阅读本协议并接受本协议的约束。</p>
            <p>好享家有权在必要时修改本协议条款。会员可以在相关服务页面查阅最新版本的协议条款。</p>
            <p>本协议条款变更后，如果会员继续使用好享家提供的软件或服务，即视为会员已接受修改后的协议。如果会员不接受修改后的协议，应当停止使用好享家提供的软件或服务。</p>

            <p class="bold">九、【服务的变更、中断、终止】</p>
            <p>9.1 好享家可能会对服务内容进行变更，也可能会中断、中止或终止服务。</p>
            <p>9.2 会员理解并同意，好享家有权自主决定经营策略。在好享家发生合并、分立、收购、资产转让时，好享家可向第三方转让本服务下相关资产；好享家也可在单方通知会员后，将本协议下部分或全部服务转交由第三方运营或履行。具体受让主体以好享家通知的为准。</p>
            <p>9.3 如发生下列任何一种情形，好享家有权不经通知而中断或终止向会员提供的服务：</p>
            <p>（1）根据法律规定会员应提交真实信息，而会员提供的资料不真实、或与注册时信息不一致又未能提供合理证明；</p>
            <p>（2）会员违反相关法律法规或本协议的约定；</p>
            <p>（3）按照法律规定或主管部门的要求；</p>
            <p>（4）出于安全的原因或其他必要的情形。</p>
            <p>9.4 会员有责任自行备份存储在本服务中的数据。如果会员的服务被终止，好享家可以从服务器上永久地删除会员的数据,但法律法规另有规定的除外。服务终止后，好享家没有义务向会员返还数据。</p>

            <p class="bold">十、【管辖与法律适用】</p>
            <p class="bold">10.1 本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。</p>
            <p class="bold">10.2 本协议签订地为中华人民共和国江苏省南京市玄武区。</p>
            <p class="bold">10.3 若会员和好享家之间发生任何纠纷或争议，首先应友好协商解决；协商不成的，会员同意将纠纷或争议提交本协议签订地有管辖权的人民法院管辖。</p>
            <p>10.4 本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据。</p>
            <p>10.5 本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。</p>

            <p class="bold">十一、【其他】</p>
            <p class="bold">11.1 会员使用本服务即视为你已阅读并同意受本协议的约束。好享家有权在必要时修改本协议条款。会员可以在本软件的最新版本中查阅相关协议条款。本协议条款变更后，如果会员继续使用本服务，即视为会员已接受修改后的协议。如果会员不接受修改后的协议，应当停止使用本服务。</p>
            <p>11.2 单分享平台的《会员注册服务协议》、《隐私政策》等协议与本协议组成平台服务协议，本协议未尽事宜，以平台其他协议约定为准，其他协议未做约定的，以法律规定或政策要求为准，或双方协商确定。</p>
            <p>11.3 好享家基于提供本服务所发布的各项公告、规则等作为本协议的有效组成部分，与本协议具有同等法律效力。具体公告、规则等内容以好享家发布的为准。</p>
            <p>11.4 如果会员对本协议或本服务有意见或建议，可与的单分享平台客户服务部门联系，我们会给予会员必要的帮助。</p>

            <p class="foot">江苏好享家电子商务有限公司</p>

        </div>
    </div>
</template>

<script>
import Header from '../../common/header'
export default {
    name: 'precharge',
    components: {
        Header
    },
    data () {
        return {
            title: '预充服务协议'
        }
    },
    methods: {
        onBack () {
            this.$router.back()
        }
    }
}
</script>

<style lang="scss" scoped>
    .precharge {
        background: #ffffff;
        padding: 32px;
        p{
            line-height: 40px;
        }
        .bold {
            font-weight: bold;
        }
        .textCenter {
            text-align: center;
        }
        .subTitle {
            margin-bottom: 50px;
        }
        .foot{
            text-align: right;
            margin-top: 40px;
        }
    }
    table.gridtable {
        font-family: verdana,arial,sans-serif;
        font-size:11px;
        color:#333333;
        border-width: 1px;
        border-color: #666666;
        border-collapse: collapse;
    }
    table.gridtable th {
        border-width: 1px;
        padding: 8px;
        border-style: solid;
        border-color: #666666;
        background-color: #4682B4;
        color: #ffffff;
        &:first-child{
            width: 200px;
        }
    }
    table.gridtable td {
        border-width: 1px;
        padding: 8px;
        border-style: solid;
        border-color: #666666;
        background-color: #ffffff;
        &:first-child{
            text-align: center;
        }
    }
</style>